export const CONSTANTS = {
  MINIMUM_SEARCHEABLE_YEAR: 2005,
  EXPORT_RAW: 'EXPORT_RAW',
  EXPORT_MARKETING: 'EXPORT_MARKETING',
  EXPORT_BOTH: 'EXPORT_BOTH',
  NAVIGATE_NEXT: 'NAVIGATE_NEXT',
  NAVIGATE_PREV: 'NAVIGATE_PREV',
  DATE_FORMATS: {
    UI: 'yyyy-MM-dd',
    DATE_TIME: 'yyyy-MM-dd HH:mm',
    API: 'yyyy-MM-dd',
    DATE_TIME_FILENAME: 'yyyyMMddHHmmss',
  },
  PERCENT_SYMBOL: '%',
  RENDERER_ARRAY_SEPARATOR: ', ',
  EMPTY_VALUE: '-',
  MAX_DISPLAYED_RESULT: 10000,
  ENTER_KEY_CODE: 'Enter',
  COMPANIES_FILTER_STORAGE: {
    KEY: 'rr-companies-filter',
    // generate with https://www.uuidgenerator.net/version4
    VERSION: '7cdb6c6a-2fd0-4721-871c-a9853cdda07f',
  },
  REFINEMENT_COMPANIES_FILTER_STORAGE: {
    KEY: 'rr-refinement-companies-filter',
    // generate with https://www.uuidgenerator.net/version4
    VERSION: '90a48423-36cd-4efb-a371-fb64b0812872',
  },
  COLUMNS_STORAGE: {
    KEY_PREFIX: 'rr-columns-',
    BENCHMARKING_MATRIX_STORAGE_ID: 'benchmark-companies-data',
    // generate with https://www.uuidgenerator.net/version4
    VERSION: '18c995d6-75db-41ec-bd49-9d51aeca50c2',
  },
  COLUMNS_PRESET_STORAGE: {
    KEY_PREFIX: 'rr-columns-preset-',
    // generate with https://www.uuidgenerator.net/version4
    VERSION: '17c889d6-76db-41ec-bd49-9d52xeca33c3',
  },
  ROWS_STORAGE: {
    KEY_PREFIX: 'rr-rows-',
    // generate with https://www.uuidgenerator.net/version4
    VERSION: '424ccc3d-8d36-4f3d-becb-0291b936fbf5',
  },
  CONSOLIDATION_TOGGLE_STORAGE: {
    KEY: 'rr-companies-consolidation-toggle',
    // generate with https://www.uuidgenerator.net/version4
    VERSION: '898107fc-7732-498a-8702-10c02a17781e',
  },
  SCROLL_TOP_OFFSET: 230,
  SERVER_SIDE_MODEL: 'ServerSideRowModel',
  ERROR: 'error',
  UNKNOWN_NAME: 'UNKNOWN',
  CONNECTION_NODES_HIDDEN_COUNT: 50,
  TOOLBAR_HEIGHT: 44,
  TABLE_HEADER: 38,
  // Corresponds to MAX_DEFAULT_VERIFY_COMPANIES in the backend — keep in sync if changed
  MAX_DEFAULT_VERIFY_COMPANIES: 500,
};
